export const initialState = {
  loadingSilos: true,
  loadingCereales: true,
  tareasPendientes: {},
  tareasMovimiento: {},
  tareaInicial: '',
  valoresSilo: ''
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_SILOS_D3_VIEW':
      return {
        ...state,
        loadingSilos: action.loading,
        silosData: action.data
      }
    case 'UPDATE_CEREAL_POR_LINEA_D3_VIEW':
      return {
        ...state,
        loadingCereales: action.loading,
        cerealesData: action.data
      }
    case 'UPDATE_SILO_A_DETALLAR':
      return {
        ...state,
        detallesMovimientosSilo: action.detallesMovimientosSilo
      }
    case 'UPDATE_LINEA_A_DETALLAR':
      return {
        ...state,
        detallesMovimientosLinea: action.linea
      }
    case 'RECEIVE_TAREAS_PENDIENTES':
      return {
        ...state,
        tareasPendientes: action.data
      }
    case 'RECEIVE_TAREAS_MOVIMIENTO':
      return {
        ...state,
        tareasMovimiento: action.tareas
      }
    case 'RECEIVE_TAREA_POR_FECHA':
      return {
        ...state,
        tareaInicial: action.tareaInicial
      }
    case 'LECTURA_VALORES_SILO':
      return {
        ...state,
        valoresSilo: action.data.lecturaValoresSilos
      }
    default:
      return state
  }
}
